import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class RegionService {

    getEventRoute = '/api/region/';

    constructor(private dataService: DataService) {
    };

    getVLookUp(refresh: boolean) {
        return this.dataService.getData('/api/vehicle/lookup', refresh);
    }

    gerRawData(data:any){
        return this.dataService.getData('/api/vehiclestatus/rawdata/'+data.vehicleId+'/'+data.imeiNo+'/'+data.startTs+'/'+data.endTs, true);
    }

    DeviceLogData(data:any){
        return this.dataService.getData('/api/vehiclestatus/devicelog/'+data.vehicleId+'/'+data.startTs+'/'+data.endTs, true);
    }

    getLookUp(refresh: boolean) {
        return this.dataService.getData('/api/region/lookup', refresh);
    }

    getLookupdashboard(data:any,refresh: boolean) {
        return this.dataService.getData('/api/dbtdashboard/' + data.regionId +'/' + data.divisionI +'/' + data.subDivisionId + '/' + data.villageId + '/' + data.financialYearId + '/' + data.goId , refresh);
    }
    getLookUpFinYear(refresh: boolean) {
        return this.dataService.getData('/api/vehicletarget/financialyearlookup', refresh);
    }

    getFinYear(refresh: boolean) {
        return this.dataService.getData('/api/vehicletarget/financialyearlookup', refresh);
    }

    getUom(refresh: boolean) {
        return this.dataService.getData('/api/lookup/uomtype', refresh);
    }

    getproductConfigLookup(refresh: boolean){
        return this.dataService.getData('/api/dbtproductconfig/lookup', refresh);
    }

    getproductLookup(refresh: boolean){
        return this.dataService.getData('/api/dbtproduct/alldbtproduct', refresh);
    }

    getconfigValue(refresh: boolean){
        return this.dataService.getData('/api/lookup/allconfigdatatype', refresh);
    }

    getLookUpDelta(refresh: boolean) {
        return this.dataService.getData('/api/lookup/regiontype', refresh);
    }

    get(refresh: boolean) {
        return this.dataService.getData('/api/region', refresh);
    }

    getById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/region/' + id, refresh);
    }

    save(result: any) {
        return this.dataService.post('/api/region/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    delete(id: number) {
        return this.dataService.delete('/api/region/'+ id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    deleteBlockvillagemappingremove(id:any){
        return this.dataService.post('/api/subdivision/blockvillagemappingremove', id).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }



}
